/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useCallback, useEffect, useState, useRef } from 'react'
import Router, { SingletonRouter, withRouter } from 'next/router'
import {
  sendTeaCommEvent,
  sendTeaEnterEvent,
  sendTeaStayEvent,
} from 'lib/tea-analyze'
import PubSub from 'pubsub-js'
import Loading from 'Components/loading'
import ScrollLoader from 'Components/scroll-loader'
import fetchFeed, { IFeedData, IParams } from 'lib/fetch-feed'
import { tabs } from '../home/components/home-feed'
import Item from './nav-item'
import classnames from 'classnames'
import { parse } from 'querystring'
import { useResponsive } from 'Components/hooks/use-responsive'
import { MoreButton } from 'New/search/components/title-bar'

const MAX_LOAD_COUNT = 118

const tabsMap: {
  [key: string]: string
} = {}
tabs.forEach((item) => {
  tabsMap[item.id] = item.label
})

interface INavProps {
  router: SingletonRouter
}

const FeedNav = (props: INavProps) => {
  const responsive = useResponsive()

  const [loading, setLoading] = useState(true)
  const [videoList, setVideoList] = useState<IFeedData[]>([])

  const [handleType, setHandleType] = useState('')
  const wrapClass = React.useMemo(() => {
    return `${handleType ? handleType : 'tw-w-316 md:tw-w-390 xl:tw-w-510'}`
  }, [handleType])

  const scrollRef = useRef<HTMLDivElement>(null)

  // 现在是hover时触发加载，使用缓存处理下
  const tempStorage = useRef(new Map())

  const gidRef = useRef<any>()
  const [key, setKey] = useState('')
  useEffect(() => {
    try {
      if (props?.router?.asPath?.indexOf('?') > -1) {
        const param = parse(props?.router?.asPath?.split('?')[1])
        if (param?.['gid'] && gidRef.current !== param['gid']) {
          gidRef.current = param['gid']
          setUniqueIdStr((param['gid'] as string) || '')
          setTimeout(() => {
            PubSub.publish('FEED_NAV_UNIQUEID', {
              gid: param['gid'],
            })
          }, 0)
        }
      }
    } catch (error) {
      console.error(error)
    }
  }, [props?.router?.asPath])

  useEffect(() => {
    setKey(tabs?.[0]['id'])
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    handleChange(tabs?.[0]['id'], true)
  }, [])

  const [uniqueIdStr, setUniqueIdStr] = useState('')

  const getChannelId = (item: any) => {
    let channelId = ''
    try {
      const action_extra = item?.info?.dislike_info?.action_extra
      const { channel_id } = JSON.parse(action_extra)
      channelId = channel_id
    } catch (error) {
      console.error(error)
    }
    return channelId
  }

  const beforeRef = useRef<{
    channel_name?: string
    channel_id?: string
    group_id?: string
    tab_name?: string
    pre_page_id?: string
    content_type?: string
    star_time?: number
  }>()
  const setUniqueIdStrProxy = useCallback(
    (value: string, key: string, isUpdate: boolean, item?: any) => {
      gidRef.current = value
      setUniqueIdStr(value)
      if (isUpdate) {
        const channel_name = key
        const channel_id = `${getChannelId(item)}`
        const group_id = item?.unique_id_str
        const tab_name = tabsMap[key]
        const pre_page_id = 'page_feed_article_mix'
        const content_type =
          item?.info?.video_duration > 0 ? 'pgc_video' : 'pgc_article'
        if (!beforeRef?.current) {
          beforeRef.current = {}
        }
        if (beforeRef.current) {
          if (beforeRef.current.star_time) {
            // 拥有上一个先上报上一个stay-time
            sendTeaCommEvent('stay_page', {
              channel_name: beforeRef.current.channel_name,
              channel_id: beforeRef.current.channel_id,
              group_id: beforeRef.current.group_id,
              tab_name: beforeRef.current.tab_name,
              pre_page_id: beforeRef.current.pre_page_id,
              content_type: beforeRef.current.content_type,
              stay_time: new Date().getTime() - beforeRef.current.star_time,
            })
          }
          beforeRef.current.channel_name = channel_name
          beforeRef.current.channel_id = channel_id
          beforeRef.current.group_id = group_id
          beforeRef.current.tab_name = tab_name
          beforeRef.current.pre_page_id = pre_page_id
          beforeRef.current.content_type = content_type
          beforeRef.current.star_time = new Date().getTime()
        }
        PubSub.publish('FEED_NAV_UNIQUEID', {
          channel_id,
          channel_name,
          tab_name,
          gid: value,
        })
      }
    },
    [setUniqueIdStr]
  )

  const setHandleTypeProxy = useCallback(() => {
    sendTeaCommEvent('clk_event', {
      event_id: 'feed_list_shrink',
      shrink_type: handleType === 'off' ? 'unfold' : 'fold',
    })
    setHandleType((type: string) => {
      if (type === 'off') {
        return ''
      }
      return 'off'
    })
  }, [handleType])

  const [twoXl, setTwoXl] = useState(false)
  // xl以及以上不展示shadow
  const [shadowStatus, setShowStatus] = useState(false)
  useEffect(() => {
    if (responsive.lg === true && responsive.xl === false) {
      setTimeout(() => {
        PubSub.publish('SIDE_NAV_STATUS', 'off')
      }, 200)
    }
    if (responsive?.['2xl']) {
      setTwoXl(true)
    } else {
      setTwoXl(false)
    }
    if (responsive.xl) {
      setHandleType('')
      setShowStatus(false)
      return
    }
    setShowStatus(true)
  }, [responsive])

  useEffect(() => {
    PubSub.publish('FEED_NAV_STATUS', handleType ? handleType : 'on')
  }, [handleType])

  const [fixType, setFixType] = useState('')

  const handler = useCallback((type, value) => {
    if (value === 'on') {
      setFixType('nav-on')
      return
    }
    setFixType('nav-off')
  }, [])

  useEffect(() => {
    const token = PubSub.subscribe('SIDE_NAV_STATUS', handler)
    return () => {
      PubSub.unsubscribe(token)
    }
  }, [])

  const conditionRef = useRef<{
    id: string
    loadCount: number
    fetchId: number
  }>()
  const timerRef = useRef<any>()

  const handleMouseOver = useCallback((item) => {
    PubSub.publish('FEED_NAV_UNIQUEID_HOVER', item?.unique_id_str)
  }, [])

  const handleChange = useCallback((id, refresh: boolean) => {
    // 非刷新情况直接使用缓存
    if (!refresh && tempStorage?.current?.has(id)) {
      setVideoList(tempStorage.current.get(id))
      return
    }
    if (timerRef.current) {
      window.clearTimeout(timerRef.current)
    }
    timerRef.current = setTimeout(async () => {
      const fetchId = Math.random()
      conditionRef.current = { id, loadCount: 0, fetchId }
      setLoading(true)
      setVideoList([])

      const playLoad: IParams = {
        tt_from: 'enter_auto',
        category: conditionRef?.current?.id,
        count: 8,
        motor_feed_extra_params: '{"new_feed": true, "feed_type": 0}',
      }

      const a = await fetchFeed(playLoad)
      a.data = a?.data.filter((item: IFeedData) => !item.duplicate)

      if (conditionRef?.current?.fetchId !== fetchId) {
        setLoading(false)
        return
      }

      tempStorage.current.set(id, [...a.data])
      setVideoList([...a.data])
      if (!gidRef?.current && a.data?.[0]?.['unique_id_str']) {
        // 之前没有设置的时候都会设置默认第一个
        setUniqueIdStrProxy(
          a.data?.[0]?.['unique_id_str'],
          id,
          true,
          a.data?.[0]
        )
        const url = `/feed?gid=${a.data?.[0]?.['unique_id_str']}`
        Router.push('/new_feed/home', url)
      }
      setLoading(false)
    }, 10)
  }, [])

  /* 懒加载 */
  const loadMoreHandler = useCallback(() => {
    if (
      !conditionRef?.current?.id ||
      conditionRef?.current?.loadCount > MAX_LOAD_COUNT
    ) {
      return
    }
    sendTeaCommEvent('load_refresh', {
      event_id: 'feed_refresh',
      channel_name: tabsMap[key],
    })
    setLoading(true)

    if (conditionRef.current) {
      conditionRef.current.loadCount++
    }

    fetchFeed({
      tt_from: 'load_more',
      category: conditionRef?.current?.id,
      count: 8,
      motor_feed_extra_params: '{"new_feed": true, "feed_type": 0}',
      max_behot_time: videoList?.[videoList?.length - 1]?.info?.behot_time,
    })
      .then((res) => {
        const list = res?.data?.filter((item: IFeedData) => !item.duplicate)
        setVideoList(videoList.concat(list))
        tempStorage.current.set(
          conditionRef?.current?.id,
          videoList.concat(list)
        )
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }, [key, videoList])

  const renderTypes = () => {
    return (
      <div className="feed-nav-sroll-wrap g-hover-scroll-bar">
        <a href="/news" target={'_blank'}>
          <MoreButton
            className="tw-pl-24 tw-w-full tw-text-left tw-h-50"
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'all_news_btn',
              })
            }}
          >
            全部资讯
          </MoreButton>
        </a>
        <ul className="feed-nav-type">
          {tabs.map((item: any, index: number) => {
            return (
              <li
                className={classnames('type-item', {
                  active: key === item.id,
                })}
                onClick={() => {
                  setKey(item.id)
                  handleChange(item.id, false)
                  sendTeaCommEvent('clk_event', {
                    event_id: 'left_channel_nav',
                    tab_name: item.label,
                  })
                  // 每一次切换频道，上报page_enter
                  sendTeaStayEvent()

                  const feedParams = {
                    page_id: 'page_feed_article_mix',
                    sub_tab: item.label,
                  }
                  sendTeaEnterEvent(feedParams)

                  // 点击每次滚动至顶部
                  // eslint-disable-next-line no-unused-expressions
                  scrollRef?.current?.scrollTo?.(0, 0)
                }}
                key={`side-${index}`}
              >
                {item.label}
              </li>
            )
          })}
        </ul>
        <style jsx>
          {`
            .feed-nav-sroll-wrap {
              position: absolute;
              left: 0;
              width: 112px;
              background: #f7f8fc;
              height: 100%;
              overscroll-behavior: contain;
              z-index: 8;
            }
            .feed-nav-type {
              width: 112px;
            }
            .type-item {
              width: 112px;
              height: 55px;
              line-height: 55px;
              padding-left: 24px;
              font-size: 16px;
              color: #606370;
            }
            .type-item.active {
              background: #ffcc32;
              color: #1f2129;
            }
            .type-item:hover {
              background: #fff2ce;
              color: #1f2129;
              cursor: pointer;
            }
            .type-item.active:hover {
              background: #ffcc32;
            }
          `}
        </style>
      </div>
    )
  }

  const handleGoDetail = useCallback(
    (item: any) => {
      sendTeaCommEvent('clk_event', {
        event_id: 'feed_item',
        channel_name: key,
        channel_id: getChannelId(item),
        group_id: item?.unique_id_str,
        tab_name: tabsMap[key],
        content_type:
          item?.info?.video_duration > 0 ? 'pgc_video' : 'pgc_article',
      })
      setUniqueIdStrProxy(item.unique_id_str, key, true, item)
      const url = `/feed?gid=${item.unique_id_str}`
      Router.push('/new_feed/home', url)
    },
    [key]
  )

  const renderList = () => {
    return (
      <>
        <div className="feed-nav-list">
          <ScrollLoader
            loading={loading}
            loadMoreHandler={loadMoreHandler}
            end={false}
          >
            <div>
              {videoList?.map((item: any, index: number) => {
                return (
                  <div
                    key={index}
                    className={classnames(
                      'item-wrap tw-col-span-3 xl:tw-col-span-2',
                      {
                        active: uniqueIdStr === item.unique_id_str,
                      }
                    )}
                    onMouseOver={() => handleMouseOver(item)}
                    onClick={() => handleGoDetail(item)}
                  >
                    <Item
                      order={index}
                      category={conditionRef?.current?.id || ''}
                      uniqueIdStr={item.unique_id_str}
                      title={item?.info?.title}
                      imageList={item?.info?.image_list}
                      name={item?.info?.user_info?.name}
                      userId={item?.info?.user_info?.user_id}
                      commentCount={item?.info?.comment_count}
                      duration={item?.info?.video_duration}
                    />
                  </div>
                )
              })}
            </div>
            {loading ? <Loading /> : null}
          </ScrollLoader>
        </div>
        <style jsx>
          {`
            .feed-nav-list {
              position: relative;
              padding: 0 0 20px 0;
              background-image: linear-gradient(to left, #fcfcfe 99%, #f7f8fc);
            }
            .item-wrap.active {
              background-color: #e6e8f2;
            }
            .item-wrap:hover {
              background-color: rgba(255, 204, 50, 0.2);
            }
          `}
        </style>
      </>
    )
  }

  const renderContent = () => {
    return (
      <>
        {renderTypes()}
        <div
          className="feed-nav-content-wrap g-hover-scroll-bar tw-w-204 md:tw-w-278 xl:tw-w-398"
          ref={scrollRef}
        >
          <div className="feed-nav-content tw-w-204 md:tw-w-278 xl:tw-w-398">
            {videoList?.length ? (
              renderList()
            ) : loading ? (
              <Loading className={'feed-nav-loading'} />
            ) : (
              <p className={'feed-nav-tips'}>
                <span className="tips">网路顿时有些拥堵</span>
                <span className="tips">请点击重新加载，刷新资讯</span>
                <span
                  className="handle-button"
                  onClick={() => handleChange(key, true)}
                >
                  重新加载
                </span>
              </p>
            )}
          </div>
        </div>
        <style jsx>
          {`
            .feed-nav-content-wrap {
              position: absolute;
              top: 55px;
              right: 0;
              bottom: 0;
              overscroll-behavior: contain;
            }
            .feed-nav-tips {
              position: absolute;
              width: 100%;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              font-size: 12px;
              color: #979aa8;
              text-align: center;
            }
            .tips {
              display: block;
            }
            .handle-button {
              display: inline-block;
              margin-top: 8px;
              width: 72px;
              height: 24px;
              padding: 3px 0;
              border-radius: 2px;
              border: solid 0.5px #c9cbd6;
              cursor: pointer;
            }
            .handle-button:hover {
              background-color: #ffffff;
            }
          `}
        </style>
      </>
    )
  }

  const renderSwitchButton = () => {
    return (
      <p
        className={`switch-button ${handleType} xl:tw-hidden`}
        onClick={setHandleTypeProxy}
      >
        {handleType === 'off' ? '展开' : '收起'}
        <style jsx>
          {`
            .switch-button {
              opacity: 0;
              transition: opacity 0.3s ease-in-out;
            }
            .switch-button.off {
              position: absolute;
              opacity: 1;
              cursor: pointer;
              top: 106px;
              right: -30px;
              width: 30px;
              height: 84px;
              padding: 16px 8px 0 8px;
              border-top-right-radius: 8px;
              border-bottom-right-radius: 8px;
              background-color: #e9ecf7;
            }
            .switch-button:after {
              content: '';
              position: absolute;
              width: 0;
              height: 0;
              margin-top: 24px;
              margin-left: -11px;
              border-right: 4px solid transparent;
              border-left: 4px solid transparent;
              border-top: 5px solid #1f2129;
              transform: rotate(${handleType ? '-90deg' : '90deg'});
            }
          `}
        </style>
      </p>
    )
  }

  return (
    <div className={`feed-nav-wrap ${wrapClass}`}>
      <div
        className={`feed-nav-fix-wrap ${wrapClass} left-nav-fix-wrap ${
          twoXl ? '' : fixType
        }`}
      >
        {tabs?.length ? (
          renderContent()
        ) : (
          <Loading className={'feed-nav-loading'} />
        )}
        <p className="top-button">
          <span
            className="off-button xl:tw-hidden"
            onClick={setHandleTypeProxy}
          >
            收起
          </span>
          <span
            className="swith-button fr"
            onClick={() => {
              handleChange(key, true)
              sendTeaCommEvent('clk_event', {
                event_id: 'feed_list_load_refresh',
              })
            }}
          >
            换一批
          </span>
        </p>
        {renderSwitchButton()}
      </div>
      <style jsx>
        {`
          .nav-on.left-nav-fix-wrap {
            left: 160px !important;
          }

          .nav-off.left-nav-fix-wrap {
            left: 88px !important;
          }
          :global(.feed-nav-wrap .feed-nav-loading) {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .feed-nav-wrap {
            z-index: 9;
            transition: width 0.2s ease-in-out;
          }
          .feed-nav-wrap.off {
            width: 112px;
          }
          .feed-nav-fix-wrap.off {
            width: 112px;
          }
          .feed-nav-fix-wrap {
            transition: width 0.2s ease-in-out;
            box-shadow: ${shadowStatus
      ? '10px 2px 12px 0 rgba(31, 33, 41, 0.04)'
      : 'none'};
            position: fixed;
            height: calc(100vh - 84px);
            top: 84px;
            background: #fff;
          }
          .top-button {
            position: absolute;
            height: 55px;
            border-left: 112px solid transparent;
            width: 100%;
            background: #fff;
            top: 0;
            right: 0;
            font-size: 14px;
            cursor: pointer;
            color: #1f2129;
            padding: 20px 24px 0 24px;
            box-shadow: 0 4px 4px 0 rgba(31, 33, 41, 0.01);
          }
          .off-button {
            float: left;
            cursor: pointer;
          }
          .off-button:after {
            content: '';
            display: inline-block;
            position: absolute;
            width: 0;
            height: 0;
            margin-top: 9px;
            margin-left: 2px;
            border-right: 4px solid transparent;
            border-left: 4px solid transparent;
            border-top: 5px solid #1f2129;
            transform: rotate(90deg);
          }
          .swith-button {
            cursor: pointer;
            font-size: 14px;
          }
          .swith-button:after {
            content: '';
            display: inline-block;
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-left: 2px;
            background: url(${require('static/refresh-new.png')}) no-repeat
              center / 16px 16px;
          }
        `}
      </style>
    </div>
  )
}

export default withRouter<INavProps>(FeedNav)
